import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import api from "../../utils/api";
import { keyframes } from "@mui/system";

const slideIn = keyframes`
  from {
    transform: translateX(50%);
  }
  to {
    transform: translateX(-100%);
  }
`;

const NotificationTicker = () => {
  const [notifications, setNotifications] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fetchNotifications = async () => {
    try {
      const response = await api.get("/notifications/active");
      setNotifications(response.data.data.notifications);
    } catch (err) {
      // console.error("Failed to fetch notifications:", err);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000); // Refresh every minute
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (notifications.length > 0) {
      const timer = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % notifications.length);
      }, 10000); // Change notification every 10 seconds
      return () => clearInterval(timer);
    }
  }, [notifications.length]);

  if (!notifications.length) return null;

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "primary.main",
        color: "white",
        p: 1,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Box
        sx={{
          animation: `${slideIn} 20s linear infinite`,
          whiteSpace: "nowrap",
          display: "inline-block",
        }}
      >
        <Typography variant="body1" component="span">
          {notifications[currentIndex]?.message}
        </Typography>
      </Box>
    </Box>
  );
};

export default NotificationTicker;
